import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-editor-custom-component-text-config',
  templateUrl: 'text-config.component.html'
})
export class TextConfigComponent {
  @Input() item: any;
  @Input() layout: number;
  @Input() customData: any;
  @Output() public sendEvent = new EventEmitter<any>();

  constructor(
  ) {
  }

  emitSendEvent() {
    this.sendEvent.emit();
  }

}
